import { Link } from 'react-router-dom';
import styled from 'styled-components';

/** Served from `public/img/logo.png` (synced from repo `assets/images/logo/logo.png`). */
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL}/img/logo.png`;

export const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  line-height: 0;

  &:hover {
    opacity: 0.92;
  }
`;

export const LogoImage = styled.img`
  display: block;
  height: ${({ $size }) => $size || 32}px;
  width: auto;
  object-fit: contain;
`;
